import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('vm-chat-mobile-trigger')
export class VmChatMobileTrigger extends LitElement {
    override createRenderRoot() {
        return this;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-chat-mobile-trigger': VmChatMobileTrigger;
    }
}
